var React = require('react');

function WarningCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 31.5C25.4558 31.5 31.5 25.4558 31.5 18C31.5 10.5442 25.4558 4.5 18 4.5C10.5442 4.5 4.5 10.5442 4.5 18C4.5 25.4558 10.5442 31.5 18 31.5Z","stroke":"black","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18 11.25V18.5625","stroke":"black","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M18 26.4375C19.2426 26.4375 20.25 25.4301 20.25 24.1875C20.25 22.9449 19.2426 21.9375 18 21.9375C16.7574 21.9375 15.75 22.9449 15.75 24.1875C15.75 25.4301 16.7574 26.4375 18 26.4375Z","fill":"black","key":2})]);
}

WarningCircle.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = WarningCircle;

WarningCircle.default = WarningCircle;
